import { Vertical } from '@sorare/core/src/atoms/layout/flex';
import { Cryptocurrency } from '@sorare/core/src/components/settings/Cryptocurrency';
import { Currency } from '@sorare/core/src/components/settings/Currency';
import { LocalCurrency } from '@sorare/core/src/components/settings/LocalCurrency';
import { RewardCurrency } from '@sorare/core/src/components/settings/RewardCurrency';
import {
  SettingsPage,
  TITLES,
} from '@sorare/core/src/components/settings/pages';

import { SettingsWrapper } from '#src/components/settings/SettingsWrapper/index.tsx';

export const Currencies = () => {
  return (
    <SettingsWrapper pageTitle={TITLES[SettingsPage.CURRENCIES]}>
      <Vertical gap={2}>
        <LocalCurrency />
        <Cryptocurrency />
        <RewardCurrency />
        <Currency />
      </Vertical>
    </SettingsWrapper>
  );
};

export default Currencies;
